export const OFFERS_API_SUCCESS = 'OFFERS_API_SUCCESS'
export const OFFERS_API_FAIL = 'OFFERS_API_FAIL'
export const ADD_FAVOURITES_API_SUCCESS = 'ADD_OFFERS_API_SUCCESS'
export const ADD_FAVOURITES_API_FAIL = 'ADD_OFFERS_API_FAIL'
export const REMOVE_FAVOURITES_API_SUCCESS = 'REMOVE_OFFERS_API_SUCCESS'
export const REMOVE_FAVOURITES_API_FAIL = 'REMOVE_OFFERS_API_FAIL'



// WEBPACK FOOTER //
// ./services/app-state/personalizedRecommendation/constants.js